import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../plugins/store.js'

Vue.use(VueRouter)

const routes = [
 
 
    {
        path: '/Login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
        meta: {
            allowAnonymous: true
        }
    },

      {
        path: '/InformedDelivery',
        name: 'InformedDelivery',
        component: () => import(/* webpackChunkName: "about" */ '../views/InformedDelivery.vue'),
        meta: {
            allowAnonymous: false
        }
    },

    {
        path: '/MyProfile',
        name: 'MyProfile',
        component: () => import('../views/MyProfile.vue'),
        meta: {
            allowAnonymous: false
        }
    },
    {
        path: '/UserManagement',
        name: 'UserManagement',
        component: () => import('../views/UserManagement.vue'),
        meta: {
            allowAnonymous: false
        }
    },
    {
        path: '/Home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
            allowAnonymous: false
        }
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeResolve((to, from, next) => {
    
    if (!to.meta.allowAnonymous && !store.state.user.isAuthenticated) {

        next({
            path: '/Login',
            query: { redirect: to.fullPath }
        })
    }
    else if (to.meta.allowAnonymous)
    {
        next();
    }
    else if (store.state.user.isAuthenticated && to.matched.length != 0 && !to.meta.allowAnonymous)
    {
        next()
    }

    else {
              // eslint-disable-line no-debugger
            var customerModules = store.getters.user.customerModules;

            if (customerModules.length == 1) {
                router.push({
                    name: customerModules[0].routerLink,
                    path: customerModules[0].routerLink,
                    query: { modulekey: customerModules[0].moduleKey },
                    params:{ modulekey: customerModules[0].moduleKey } 
                })
            }
            else {
               router.push('Home')
            }
        }
})

export default router
